
import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

interface ProjectCardProps {
  title: string;
  description: string;
  imageUrl: string;
  tags: string[];
  projectUrl: string;
}

const ProjectCard: React.FC<ProjectCardProps> = ({ 
  title, 
  description, 
  imageUrl, 
  tags,
  projectUrl 
}) => {
  return (
    <Card className="project-card overflow-hidden border-0 shadow-md">
      <div className="relative h-64">
        <img 
          src={imageUrl} 
          alt={title} 
          className="w-full h-full object-cover"
        />
        <div className="project-card-overlay absolute inset-0 bg-primary/80 flex flex-col justify-center items-center p-6">
          <h4 className="text-white font-bold text-xl mb-2">{title}</h4>
          <p className="text-white/90 text-center mb-4">{description}</p>
          <Button asChild variant="secondary">
            <a href={projectUrl} target="_blank" rel="noopener noreferrer">
              View Project
            </a>
          </Button>
        </div>
      </div>
      {/* <CardContent className="p-4">
        <h4 className="font-semibold mb-2">{title}</h4>
        <div className="flex flex-wrap gap-1">
          {tags.map((tag, index) => (
            <span 
              key={index}
              className="text-xs px-2 py-1 bg-secondary rounded-full"
            >
              {tag}
            </span>
          ))}
        </div>
      </CardContent> */}
    </Card>
  );
};

export default ProjectCard;
